import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import FaIcon from '@/components/FaIcon.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import { scrollTo } from '@/utils/viewport';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import {
  computed, inject,
} from 'vue';
import { getBaseButtonCSSMargin } from '@/utils/BaseCSSHelper.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    color: { default: 'power' },
    width: { default: 'auto' },
    textAlign: { default: 'center' },
    align: { default: 'center' },
    linkType: { default: 'page' },
    pageUrl: {},
    mediaUrl: {},
    url: {},
    anchor: {},
    icon: {},
    branch: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "51e9a125": (_unref(alignment))
}))

library.add(faSpinner);

const props = __props;

const injectedAlignment = inject<string | undefined>('cardItemsAlign', undefined);
const alignment = injectedAlignment || props.textAlign;

const classes = computed(() => {
  const btnClasses = [];

  btnClasses.push(`btn-${props.color}`);
  btnClasses.push(`app-bg-${props.color} gradient`);

  if (props.width !== undefined) {
    btnClasses.push(props.width);
  }

  if (props.icon !== undefined) {
    btnClasses.push('btn--icon');
  }

  if (props.loading) {
    btnClasses.push('loading');
  }

  return btnClasses;
});

const style = computed(() => {
  const styles = {} as Record<string, string | undefined>;

  if (props.width !== 'full') {
    styles['--base-button-margin'] = getBaseButtonCSSMargin(props.align);
  }

  styles['--base-icon-grid-margin'] = getBaseButtonCSSMargin(alignment);

  return styles;
});

const isEmail = (email: string) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const buttonUrl = computed<string>(() => {
  let url;

  switch (props.linkType) {
    case 'page':
      url = props.pageUrl;
      break;
    case 'document':
      url = props.mediaUrl;
      break;
    case 'url':
      if (props.url && isEmail(props.url) && props.url.indexOf('mailto:') !== 0) {
        url = `mailto:${props.url}`;
      }
      url = props.url;
      break;
    default:
      url = undefined;
  }

  url = `${url || ''}`.trim();

  const anchor = `${props.anchor || ''}`.trim();

  if (
    props.linkType !== 'document'
      && anchor.length
  ) {
    url = `${url}#${anchor}`;
  }

  return url;
});

const buttonTarget = computed<string>(() => {
  switch (props.linkType) {
    case 'document':
    case 'url':
      if (props.url?.indexOf('javascript') === 0) {
        return '_self';
      }
      return '_blank';

    default:
      return '_self';
  }
});

const navigate = (next: () => void) => {
  if (props.linkType !== 'anchor') {
    next();
    return;
  }

  scrollTo(props.anchor || '', {
    windowPercentage: 0.2,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_ctx.linkType !== 'button')
    ? (_openBlock(), _createBlock(_component_IoRouterLink, {
        key: 0,
        "link-url": buttonUrl.value,
        class: _normalizeClass(["base-button", classes.value]),
        "link-target": buttonTarget.value,
        style: _normalizeStyle(style.value),
        "custom-handler": navigate
      }, {
        default: _withCtx(() => [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createElementVNode("span", null, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                (_ctx.icon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createVNode(FaIcon, { icon: _ctx.icon }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ]))
        ]),
        _: 3
      }, 8, ["link-url", "class", "link-target", "style"]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(["base-button", classes.value]),
        style: _normalizeStyle(style.value)
      }, [
        (_ctx.icon || _ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createElementVNode("span", null, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createElementVNode("span", null, [
                (_ctx.icon)
                  ? (_openBlock(), _createBlock(FaIcon, {
                      key: 0,
                      icon: _ctx.icon
                    }, null, 8, ["icon"]))
                  : (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                      key: 1,
                      icon: "fa-light fa-spinner",
                      class: "fa-pulse"
                    }))
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ]))
      ], 6))
}
}

})